import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { selectFailureWebViewPaymentStatusModalViewState } from '../store/selectors';
import {
  openFailureWebViewPaymentStatusAlertModal,
  togglePromotionModalView,
  setProfilePromotionItemId
} from '../actions';
import iconFailed from '../public/static/images/icon-payment-status-failed.svg';
import iconWarning from '../public/static/images/icon-payment-status-warning.svg';

export const useWebViewFailurePaymentAlertModal = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const {
    isVisible: isOpenWebViewFailureAlertModal,
    type,
    errorMessage: failureWebViewAlertModalErrorMessage
  } = useSelector(selectFailureWebViewPaymentStatusModalViewState);

  const onAcceptWebViewFailureHandler = () => {
    dispatch(
      openFailureWebViewPaymentStatusAlertModal({
        isVisible: false,
        type
      })
    );
    if (type === 'warning') {
      if (window.location.hash.includes('#')) {
        const routeWithoutHash = window.location.href.split('#')[0];

        window.location.replace(routeWithoutHash);
      }
    }
  };

  let failureWebViewAlertModalIcon = iconFailed;
  let failureWebViewAlertModalTitle = t('webview.payments.errors.title');
  let failureWebViewAlertModalMessage = t('webview.payments.errors.message');
  let failureWebViewAlertModalButtonTitle = t('webview.buttons.failure');

  useEffect(() => {
    if (type === 'warning') {
      dispatch(togglePromotionModalView(false));
      dispatch(setProfilePromotionItemId(null));
    }
  }, [type, dispatch]);

  if (type === 'warning') {
    failureWebViewAlertModalIcon = iconWarning;
    failureWebViewAlertModalTitle = t(
      'webview.payments.errors.duplicate_payment_title'
    );
    failureWebViewAlertModalMessage = t(
      'webview.payments.errors.duplicate_payment_message'
    );
    failureWebViewAlertModalButtonTitle = t('webview.buttons.success');
  }

  return {
    isOpenWebViewFailureAlertModal,
    onAcceptWebViewFailureHandler,
    failureWebViewAlertModalTitle,
    failureWebViewAlertModalErrorMessage,
    failureWebViewAlertModalMessage,
    failureWebViewAlertModalButtonTitle,
    failureWebViewAlertModalIcon
  };
};
